import React from "react";
import { array } from "prop-types";
import "./footnotes.scss";

const propTypes = {
  footnotes: array,
};

const Footnotes = (props) => {
  const footnotes = props.footnotes;
  return (
    <div className="footnotes">
      {footnotes.map((footnote, i) => {
        return (
          <div key={i} className="footnotes__footnote">
            {footnote}
          </div>
        );
      })}
    </div>
  );
};

Footnotes.propTypes = propTypes;
export default Footnotes;
